import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import "./style/FuturesPanel.scss"

type FuturesAsset = {
  symbol: string
  pnl: number
  balance: number
  margin: number
  icon: string
  name: string
}

const MOCK_FUTURES: FuturesAsset[] = [
  {
    symbol: "BTC",
    pnl: 0,
    balance: 0.0,
    margin: 0,
    icon: "https://assets.coingecko.com/coins/images/1/large/bitcoin.png",
    name: "Bitcoin"
  }
]

const FuturesPanel = () => {
  const [positions, setPositions] = useState<FuturesAsset[]>([])
  const navigate = useNavigate()

  useEffect(() => {
    setPositions(MOCK_FUTURES)
  }, [])

  const handleTrade = (symbol: string) => {
    const pair = `${symbol}_USDT`
    navigate(`/exchange/${pair}`)
  }

  const handleOpen = (symbol: string) => {
    alert(`Open position for ${symbol}`)
  }

  const handleClose = (symbol: string) => {
    alert(`Close position for ${symbol}`)
  }

  return (
    <div className="futures-panel">
      <div className="header">
        <h2>Futures Wallet</h2>
        <div className="note">Mocked live PnL & Margin data</div>
      </div>

      <table className="futures-table">
        <thead>
          <tr>
            <th>Asset</th>
            <th>Balance</th>
            <th>Margin (USDT)</th>
            <th>PnL (24h)</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {positions.map(asset => (
            <tr key={asset.symbol}>
              <td className="asset-cell">
                <img src={asset.icon} alt={asset.symbol} />
                <div>
                  <div className="symbol">{asset.symbol}</div>
                  <div className="name">{asset.name}</div>
                </div>
              </td>
              <td>{asset.balance}</td>
              <td>${asset.margin.toFixed(2)}</td>
              <td className={asset.pnl >= 0 ? "positive" : "negative"}>
                {asset.pnl >= 0 ? "+" : "-"}${Math.abs(asset.pnl).toFixed(2)}
              </td>
              <td className="actions">
                <button onClick={() => handleOpen(asset.symbol)}>Open</button>
                <button onClick={() => handleClose(asset.symbol)}>Close</button>
                <button onClick={() => handleTrade(asset.symbol)}>Trade</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default FuturesPanel
